import React from "react";
import { FaHourglassHalf } from "react-icons/fa6";

const InquirySendModel = () => {
  return (
    <div className="register-model">
      <div className="success-img">
        <FaHourglassHalf />
      </div>
      <div className="register-message">Inquiry Request Sent successfully</div>
      <div className="register-para">
        Your request has been sent to the admin. We will get back to you soon.
      </div>
    </div>
  );
};

export default InquirySendModel;
